import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useCategoryCustomer() {
  const api = useApi()
  const [dataCustomer, setData] = useState<SelectOptionType[]>([])
  const [isLoadingCustomer, setLoading] = useState(true)

  const refetchMarket = () => {
    setLoading(true)

    api.get("/categorycustomer/")
    .then((res: SuccessFetch<{
      payload: {
        category_customer_id: number
        category_customer_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.category_customer_name, value: item.category_customer_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    api.get("/categorycustomer/")
    .then((res: SuccessFetch<{
      payload: {
        category_customer_id: number
        category_customer_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.category_customer_name, value: item.category_customer_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { dataCustomer, isLoadingCustomer, refetchMarket }
}